import React from "react";
import {withAuth} from "../Auth";

function AccessControl(Component) {

    const AccessList = {
        "TRANSACTION_CANCELLING": 1,        // Отмена операции
        "TRANSACTION_LIMIT_SETTING": 2,     // Установка лимита на размер  операции
        "STATISTICS_ACCESS": 4,             // Доступ к статистике
        "MAIL_ALERT_SETTING": 8,            // Настройка оповещений по почте
        "PAYOUT_REGISTRY_PROCESS": 16,      // Загрузка реестра на выплаты или разовые операции
        "PAYOUT_REGISTRY_VIEW": 32,         // Просмотр реестра
        "PAYOUT_REGISTRY_REPORT": 64,       // Выгрузка отчета по реестру
        "PAYOUT_REGISTRIES_LIST": 128,      // Просмотр списка реестров
        "PREPAID_CARDS_VIEW": 256,          // Просмотр раздела пре-активированных карт
        "PREPAID_CARDS_ACTIVATE": 512,      // Активация пре-активированной карты
        "STATISTICS_REPORT_1C_VIEW": 1024,  // Просмотр виджета выгрузки 1С
        "ACCESS_PAYOUTS": 2048,
        "ACCESS_METAL": 4096,
        "ACCESS_SBP_REGISTRY": 8192,
        "ACCESS_SBP_PAYOUT": 16384,
        "ACCESS_ANTIFRAUD_FILE": 32768,
        "ACCESS_ANTIFRAUD_SINGLE": 65536
    }

    return withAuth((props) => {

        if (props.access !== undefined && props.access === true)
            return <Component {...props} hasAccess={true}/>

        let accessCount = 0;

        if (props.access) {
            props.access.map(el => accessCount += AccessList[el]);
        }

        // Глобальные права: если включены, проверяем по глобальной маске
        if (props.globalPrivileges !== null && props.globalPrivileges !== undefined) {
            const hasAccess = (accessCount & props.globalPrivileges) > 0;
            return <Component {...props} hasAccess={hasAccess}/>
        }

        // Per-merchant права
        let currentAccess = 0;

        if (props.accountAccessSettings) {
            props.accountAccessSettings.map(el => {

                if (props.hasOwnProperty('merchantUUID')) {
                    if (el.merchantUUID === props.merchantUUID)
                        currentAccess = el.privileges;
                } else {
                    if ((accessCount & el.privileges) > 0) {
                        currentAccess = el.privileges
                    }
                }

                return null
            })
        }

        const hasAccess = (accessCount & currentAccess) > 0;

        return <Component {...props} hasAccess={hasAccess}/>
    })
}

export default AccessControl;


// WEBPACK FOOTER //
// ./src/hoc/AccessControl/index.js